import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import cloudSvg from '@/assets/svg/cloud.svg';
import treeSvg from '@/assets/svg/tree.svg';
import { TreeClickTest } from '@/components/TreeClickTest/TreeClickTest';

const CAMPAIGNS: Record<
  string,
  { name: string; wfsUrl: string; treesPlanted: number; image: string }
> = {
  'moyee-linkedin': {
    name: 'Moyee Coffee x LinkedIn',
    wfsUrl: `${import.meta.env.VITE_GEO_SERVER}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geonode:campaign_trees_moyee_linkedin&outputFormat=application/json`,
    treesPlanted: 120,
    image:
      'https://storage.googleapis.com/fairchain-images/trees/files/20231017075551821_QFieldCamera20231017_1055512105148237675599868.jpg',
  },
  'the-other-bar': {
    name: 'The Other Bar',
    wfsUrl: `${import.meta.env.VITE_GEO_SERVER}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geonode:campaign_trees_other_bar&outputFormat=application/json`,
    treesPlanted: 250,
    image:
      'https://storage.googleapis.com/fairchain-images/trees/files/20231017075551821_QFieldCamera20231017_1055512105148237675599868.jpg',
  },
};

const CO2_PER_TREE_KG = 25;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
`;

const Sidebar = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  gap: 20px;
`;

const Card = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  width: 380px;
  height: 150px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;

const CardImage = styled.img`
  width: 200px;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 80%;
  gap: 10px;
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
`;

const Description = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;
  p {
    font-family: 'Roboto', sans-serif;
    line-height: 15px;
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
`;

export const CampaignDashboard = () => {
  const { id } = useParams<{ id: string }>();
  const campaign = id ? CAMPAIGNS[id] : null;

  if (!campaign) {
    return <div style={{ padding: 24 }}>Campaign not found</div>;
  }

  const co2Kg = campaign.treesPlanted * CO2_PER_TREE_KG;
  const co2Display =
    co2Kg >= 1000
      ? `${(co2Kg / 1000).toFixed(2)} Mton CO2 sequestered`
      : `${co2Kg}kg CO2 sequestered`;

  return (
    <Wrapper>
      <TreeClickTest wfsUrl={campaign.wfsUrl} />
      <Sidebar>
        <Card>
          <CardImage src={campaign.image} alt={campaign.name} />
          <InfoBlock>
            <Title>{campaign.name}</Title>
            <Description>
              <img src={cloudSvg} />
              <p>{co2Display}</p>
            </Description>
            <Description>
              <img src={treeSvg} />
              <p>{campaign.treesPlanted} Trees planted</p>
            </Description>
          </InfoBlock>
        </Card>
      </Sidebar>
    </Wrapper>
  );
};
